<template>
  <div>
     <van-nav-bar v-show="showPath"
      @click-left="$router.go(-1)"
      left-arrow
      left-text="返回"  />
    <!-- <van-nav-bar @click-left="$router.go(-1)" left-arrow /> -->
    <div style="padding-bottom: 1rem;padding-top:0.25rem">
      <div class="card">
        <div class="title">
          <span style="height:0.5rem; padding:0.1rem;background:#37A5DA;margin-right:0.2rem">&nbsp;</span>
          订阅信息
        </div>
        <div class="list">
          <div class="list-item">
            <span>产品名称：</span>
            <span>{{ query.productName }} 
        <!-- <span v-show="query.type==0">
                <span v-if="query.productName=='月卡'"> / 1个月<span style="margin-left:0.45rem">￥10</span></span>
                <span v-if="query.productName=='半年卡'"> / 6个月<span style="margin-left:0.45rem">￥55</span></span>
                <span v-if="query.productName=='年卡'"> / 12个月<span style="margin-left:0.45rem">￥100</span></span>
              </span> -->
              ￥{{ query.productPrice / 100 }}
            </span>
          </div>
          <div class="list-item">
            <span>订阅人数：</span>
            <span>{{ query.packageName }}
              <!-- query.type为0代表普通订阅 -->
               <span style="margin: 0 0.45rem" v-show="query.type==0">
                {{ query.discount == 1 ? "原价" : query.discount * 10 + "折" }}
              </span>
            </span>
          </div>
          <div class="list-item">
            <span>购买人：</span> <span style="margin-right:0.45rem">{{ query.userName }}</span>{{ query.userMobile }}
          </div>
          <!-- <div class="list-item">
            <span>手机号：</span> <span></span>
          </div> -->
          <div class="list-item" v-if="query.child">
            <span>孩子信息：</span>
            <div  >
              <span>
                {{ query.child.name }}
                <span style="margin: 0 0.45rem">{{query.child.schoolName}}</span>
                {{ query.child.className }}
              </span>
              <br/>
              <span v-if="query.payTime&&query.type==1" class="dueTime">
                服务已订阅
              </span>
              <span v-else-if="query.payTime" class="dueTime">订阅到期时间：{{ getDateYMD(query.dueDate) }}</span>
              <span v-else  class="dueTime">未订阅</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <BindPerson
        type="detail"
        :num="query.orderNumber"
        ref="bindDetail"
        v-show="query.userNumber !== 1"
      /> -->
      <div class="card" style="padding-bottom:0.18rem">
        <div class="card-title">
          <span class="orderName">&nbsp;</span>
          订阅人员
        </div>
        <div class="bind-list">
          <div class="bind-list-item bind-mb">
            <div class="bind-t-1">
              订阅人
            </div>
            <div class="bind-t-2">
              绑定手机号
            </div>
            <div class="bind-t-3" v-show="true">
              <!-- <div class="add">添加</div> -->
            </div>
          </div>
          <div
            class="bind-list-item"
            v-for="(item, index) in addPersonData"
            :key="index"
          >
            <div class="bind-t-1">
              {{ item.bandingUserName }}
            </div>
            <div class="bind-t-2">
              {{ item.bandingUserPhone }}
            </div>
            <div class="bind-t-3">
              <img src="@/assets/del.png" alt="" v-show="false" />
            </div>
          </div>
        </div>
      </div>

      <div class="card" style="padding-bottom:0.6rem;padding-top:0.6rem">
        <div class="list">
          <div class="list-item">
            <van-row style="font-size:0.85rem;width:100%;text-align:center">
              <van-col span="8">
                <span style="color:#666666">总价：</span>￥{{ query.originalPrice / 100 }}
              </van-col>
              <van-col span="8">
                <span style="color:#666666">优惠：</span>￥{{ (query.originalPrice - query.realPrice) / 100 }}
              </van-col>
              <van-col span="8">
                <span style="color:#666666">实付款：</span>￥{{ query.realPrice / 100 }}
              </van-col>
            </van-row>
          </div>
          <!-- <div class="list-item">
            <span>优惠价：</span>
            <span>￥{{ query.realPrice / 100 }} </span>
          </div>
          <div class="list-item">
            <span>已优惠：</span>
            <span>￥{{ (query.originalPrice - query.realPrice) / 100 }} </span>
            <van-icon
              name="warning-o"
              style="margin-left:0.4rem"
              @click="showAlert"
            />
          </div>
          <div class="list-item" style="justify-content: flex-end;">
            <span>应付款：</span>
            <span>￥{{ query.realPrice / 100 }} </span>
          </div> -->
        </div>
      </div>
      <div style="position:absolute;width:100%;bottom:0;left:0;padding:2rem;background:white;box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.1);">
        <van-row :gutter="20">
          <template v-if="query.orderState == 0">
            <van-col :span="12">
              <van-button
                type="info"
                class="editPeople"
                block
                round
                @click.stop="cancelHistoryOrder(query.orderNumber)"
                >取消订单</van-button
              >
            </van-col>
            <van-col :span="12">
              <van-button type="danger" block round @click="payOrder" color="rgb(230, 136, 41)"
                >付款</van-button
              >
            </van-col>
          </template>
          <template v-else>
            <!-- <van-col :span="12" >                     
              <van-button type="info" block round v-show="query.orderState==1&&query.isOrderExceed&&query.type==0" @click.stop="againOrder(query)">再来一单</van-button>
            </van-col> -->
            <van-col :span="12">
              <van-button type="info" block round @click.stop="$router.push(
                `/bindService?orderNumber=${query.orderNumber}&userNumber=${query.userNumber}&childrenId=${query.childrenId}`)" class="editPeople">
                修改订阅人员
              </van-button>
            </van-col>
          </template>
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
import BindPerson from './bindPersonCurd'
import wxSDK from '@/utils/wxSDK.service'
import assign from '@/mixins/assign'
import moment from "moment";

export default {
  mixins: [assign],

  data() {
    return {
      showPath:true,
      query: {},
      addPersonData: [],
    }
  },
  mounted(){ 
    if(window.history.length<=1){
      this.showPath=false;
    }
    if(this.$route.query.orderNumber){
      this.getOrderCDetail(this.$route.query.orderNumber);
      // this.query=this.$route.query;
      // sessionStorage.setItem("order_detail", JSON.stringify(this.$route.query));
      this.getSubPersonList(this.$route.query.orderNumber)
    }else{
      this.query = JSON.parse(sessionStorage.getItem('order_detail'))
      this.getSubPersonList(this.query.orderNumber)
    }
    console.log(this.$route.query);
    
    console.log('详情',this.query)
    // console.log(this.$refs.bindDetail.getSubPersonList(this.query.orderNumber))
    
    
  },
  computed: {
    // detailData: {
    //   get() {
    //     return JSON.parse(sessionStorage.getItem('order_detail'))
    //   },
    //   set(value) {
    //     sessionStorage.setItem('order_detail')
    //   },
    // },
  },
  methods: {
    async getOrderCDetail(orderNum){
      let {code,data} =await this.getOrderDetail( orderNum );
      if(code!==200){
        return;
      }
      console.log('我是接口获取到的订单详情：');
      console.log(data);
      this.query=data;
      this.query.isOrderExceed= moment(this.query.dueDate).isAfter(moment());
      sessionStorage.setItem("order_detail", JSON.stringify(this.query)); 
    },
    async cancelHistoryOrder(num) {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "您确定取消订单吗？",
        })
        .then(() => {
          this.cancelOrder(num)
        })
        .catch(() => {
          // on cancel
        });
    },
    async cancelOrder(num) {
      const { data, code } = await this.$https.cancelOrder({
        orderNumber: num,
      })
      if (code !== 200) {
        this.$toast('取消订单失败')
        return
      }
      this.$toast('取消订单成功')
      this.$router.go(-1)
    },
    getDateYMD(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    async againOrder(value) {
      const { data, code, msg } = await this.getOrderDetail(value.orderNumber);
      if (code !== 200) {
        this.$toast("获取详情失败");
        return;
      }
      console.log("详情", data);
      const item = data;
      sessionStorage.setItem(
        "shopping_cart",
        JSON.stringify({
          item: this.affirmData(item),
        })
      );
      this.$router.push({
        path: `/confirmOrder`,
        query:{orderNumber:value.orderNumber,parentId:this.query.userId,childId:value.childrenId,schoolId:value.schoolId,productPrice:this.query.productPrice}
      });
      console.log("再来一单", data);
    },
    affirmData(item) {
      const originalPrice = (item.originalPrice / 100).toFixed(0);
      const realPrice = (originalPrice * item.discount).toFixed(0);
      const differencePrice = (originalPrice - realPrice).toFixed(0);
      return {
        productName: item.productName,
        packageName: item.packageName,
        originalPrice: originalPrice,
        discount: item.discount == 1 ? "原价" : item.discount * 10 + "折",
        realPrice,
        differencePrice,
        peopleNum: item.userNumber,
        productId: item.productId,
        packageId: item.packageId,
        childRadio: item.childrenId,
        productPrice:(this.query.productPrice/100) 
      };
    },
    getOrderDetail(orderNumber) {
      return new Promise(async (resolve, reject) => {
        const res = this.$https.getOrderDetail({
          orderNumber,
        });
        resolve(res);
      });
    },
    async getSubPersonList(num) {
      try {
        const { code, data } = await this.$https.getSubPersonList({
          //schoolId: this.$store.state.pschoolId,
          orderNum: num,
        })
        if (code !== 200) {
          return false
        }
        this.addPersonData = data
        // data.forEach(item => {
        //   item.isShowList =
        // })
        // this.addPersonData = data.filter(
        //   (item) =>
        //     item.bandingUserId !==
        //     JSON.parse(localStorage.getItem('userInfo')).patriarchUserId
        // )
      } catch (error) {}
    },
    showAlert() {
      // const dis =
      //   this.query.discount == 1 ? '原价' : this.query.discount / 100 + '折'
      this.$dialog
        .alert({
          title: '优惠明细',
          message: '原价 - 享受套餐折扣 × 单价 × 套餐人数 = 优惠价格',
        })
        .then(() => {
          // on close
        })
    },
    async payOrder() {
      try {
        const { data, code, msg } = await this.$https.createPayOrder({
          outTradeNo: this.query.orderNumber,
        })
        if (code !== 200) {
          this.$toast('下单失败' + msg)
          return false
        }
        const jsinit = await wxSDK.jsSDKConfig()
        if (jsinit == 'err') {
          this.$toast('微信sdk初始化失败，请重试')
          return false
        }
        const resultPay = await wxSDK.chooseWXPay(data)
        if (resultPay == '支付失败') {
          this.$toast('支付失败')
        } else if (resultPay == '支付取消') {
          // 跳转订单列表
          this.$toast('支付取消')
        } else {
          // 支付成功
          console.log('支付成功-----', resultPay)
          const res = await this.$https.getPayOrder({
            outTradeNo: this.query.orderNumber,
          })
          if (res.code !== 200) {
            this.$toast('查询支付状态失败')
            return false
          }
          this.query.orderState = 1
          console.log('查询支付状态', res)
          // this.$router.push('/paySuccess')
        }
      } catch (error) {}
    },
  },
  components: {
    BindPerson,
  },
}
</script>

<style lang="scss" scoped>

.card {
  box-shadow: 0 0.25rem 1rem rgba(69, 91, 99, 0.1);
  background: #fff;
  margin: 1rem 0.5rem;
  border-radius: 0.75rem;
  padding-bottom: 2rem;

  .title {
    color: #1A1A1A;
    font-size: 0.88rem;
    padding: 1.06rem;
    padding-bottom: 0.5rem;
    /* border-bottom: 1px solid rgba(244, 244, 246, 0.99); */
  }

  .list {
    .list-item {
      padding: 0.3rem 1.6rem;
      color: #1A1A1A;
      font-size: 0.875rem;
      display: flex;
      align-items: center;

      /* justify-content: space-between; */
      > span:first-child {
        display: inline-block;
        width: 4.5rem;
        text-align: left;
        color: #666666;
        font-size: 0.85rem;
      }

      > span:last-child {
        font-size: 0.85rem;
      }
      .dueTime{
        font-size:0.75rem;
        color:#666666;
        position:absolute; 
        padding-top:.2rem;
      }
    }
  }
}
.card {
  .card-title {
    color: #1A1A1A;
    font-size: 0.88rem;
    padding: 1.06rem;
    padding-bottom: 0.5rem;
    /* padding-top: 0; */
    .orderName{
      height:0.5rem; 
      padding:0.1rem;
      background:#37A5DA;
      margin-right:0.2rem;
    }
  }
  .bind-list {
    padding: 0.3rem 1.5rem; 
    color: #1A1A1A;
    .bind-list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.6rem;
      &.bind-mb {
        margin-bottom: 0.6rem;
      }
      .bind-t-1 {
        width: 8rem;
        text-align: left;
        font-size: 0.85rem;
        ::deep .van-cell {
          padding: 0;
        }
      }
      .bind-t-2 {
        width: 8rem;
        text-align: left;
        font-size: 0.85rem;
        ::deep .van-cell {
          padding: 0;
        }
      }
      .bind-t-3 {
        /* width: 5rem; */
        text-align: center;
        width: 3.31rem;
        img {
          width: 1.05rem;
          height: 1.05rem;
        }
        .add {
          border: 0.06rem solid #e2bd78;
          border-radius: 0.75rem;
          width: 3.31rem;
          height: 1.25rem;
          text-align: center;
          line-height: 1.25rem;
          font-size: 0.88rem;
          color: #c28f22;
        }
      }
    }
  }
}
.editPeople{
  background: white;
  color: #1A1A1A;
  border-color: #1A1A1A;
}
</style>
